import { createAction, props } from '@ngrx/store';
import { TicketHistory } from 'src/app/core/models/itinerary.model';


export const LoadTicketHistorySuccess = createAction(
  '[Ticket History] Load Ticket History Success',
  props<{ ticketHistory: TicketHistory[] }>()

);